import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import {
  createFrontendModule,
  ApiBlueprint,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { OAuth2 } from '@backstage/core-app-api';
import React from 'react';

const oidcAuthApiRef = createApiRef<any>({ id: 'auth.oidc' });

const oidcApiExtension = ApiBlueprint.make({
  name: 'oidc',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: oidcAuthApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
          configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
          OAuth2.create({
            discoveryApi,
            oauthRequestApi,
            configApi,
            environment: 'production',
            provider: {
              id: 'oidc',
              title: 'Google (via Cognito)',
              icon: () => null,
            },
            defaultScopes: ['openid', 'email', 'profile'],
          }),
      }),
    ),
});

const customSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () =>
      (props: any) =>
        React.createElement(SignInPage, {
          ...props,
          providers: [
            {
              id: 'oidc',
              title: 'Google (via Cognito)',
              message: 'Sign in using your Google account',
              apiRef: oidcAuthApiRef,
            },
          ],
        }),
  },
});

const oidcModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcApiExtension, customSignInPage],
});

export default createApp({
  features: [catalogPlugin, navModule, oidcModule],
});
